export enum RequestParamType {
    QUERY = 'QUERY',
    ROUTE = 'ROUTE',
    BODY = 'BODY',
    FORM = 'FORM'
}